<h1 class="title" translate>HOMEPAGE.OTP.TITLE</h1>
<div class="desc under-title" translate>OTP_PAGE.DESC</div>

<app-page-wrapper>
  <!-- APP CARD -->
  <div *ngIf="showAppCard" class="ic1-my-12">
    <ng-ui-kit-card
      [header]="true"
      [data]="true"
      className="type-2"
      [text]="descText | translate: { device: deviceType, user: _deviceName }"
      type="summative"
      [button]="cardAppButton">
      <ng-container header>
        <div class="ic1-header-left">
          <label class="ic1-text-label-1" translate>{{ appCardTitle }}</label>
          <ng-ui-kit-badge
            [color]="hasApp ? 'success' : 'warning'"
            size="sm"
            [label]="
              appBadgeText | translate: { state: (iconText | translate) }
            ">
          </ng-ui-kit-badge>
        </div>
      </ng-container>
      <div class="view-data-mobile" data>
        <span
          [ngClass]="
            hasApp
              ? 'ic1-badge-success-alternative'
              : 'ic1-badge-warning-alternative'
          ">
          <span
            [innerHTML]="
              appBadgeText | translate: { state: (iconText | translate) }
            "></span>
        </span>
        <label class="ic1-text-body-1">{{
          descText | translate: { device: deviceType, user: _deviceName }
        }}</label>
      </div>
    </ng-ui-kit-card>
  </div>

  <!-- SMS CARD -->
  <div *ngIf="otpType === 'SMS' || otpType === 'PUSH'" class="ic1-my-12">
    <ng-ui-kit-card
      [header]="true"
      [data]="true"
      className="type-2"
      [text]="'OTP_PAGE.SMS.DESC' | translate: { number: telephone }"
      type="summative"
      [button]="cardSmsButton">
      <ng-container header>
        <div class="ic1-header-left">
          <label class="ic1-text-label-1" translate>OTP_PAGE.SMS.TITLE</label>
          <ng-ui-kit-badge
            color="success"
            size="sm"
            [label]="'COMMON.ACTIVE' | translate"></ng-ui-kit-badge>
        </div>
      </ng-container>
      <div class="view-data-mobile" data>
        <span class="ic1-badge-success-alternative">
          <span translate>COMMON.ACTIVE</span>
        </span>
        <label class="ic1-text-body-1">{{
          'OTP_PAGE.SMS.DESC' | translate: { number: telephone }
        }}</label>
      </div>
    </ng-ui-kit-card>
  </div>

  <!-- HARDWARE CARD -->
  <div
    *ngIf="!isTrissUser && (otpType === 'HARDWARE' || otpType === 'VASCO')"
    class="ic1-my-12">
    <ng-ui-kit-card
      [header]="true"
      [data]="true"
      className="type-2"
      [text]="hardwareDescText | translate"
      type="summative"
      [button]="cardHardwareButton">
      <ng-container header>
        <div class="ic1-header-left">
          <label class="ic1-text-label-1" translate
            >OTP_PAGE.HARDWARE.TITLE</label
          >
          <ng-ui-kit-badge
            [color]="showHWSuccess ? 'success' : 'warning'"
            size="sm"
            [label]="
              'OTP_PAGE.HARDWARE.ICON_TEXT'
                | translate: { state: (hardwareIconText | translate) }
            ">
          </ng-ui-kit-badge>
        </div>
      </ng-container>
      <div class="view-data-mobile" data>
        <span
          [ngClass]="
            showHWSuccess
              ? 'ic1-badge-success-alternative'
              : 'ic1-badge-warning-alternative'
          ">
          <span
            [innerHTML]="
              'OTP_PAGE.HARDWARE.ICON_TEXT'
                | translate: { state: (hardwareIconText | translate) }
            "></span>
        </span>
        <label class="ic1-text-body-1" translate>{{ hardwareDescText }}</label>
      </div>
    </ng-ui-kit-card>
  </div>

  <!-- VIRTUAL CARD -->
  <div *ngIf="canUseLongTermToken" class="ic1-my-12">
    <ng-ui-kit-card
      type="summative"
      [title]="'OTP_PAGE.VIRTUAL.TITLE' | translate"
      [text]="'OTP_PAGE.VIRTUAL.DESC' | translate"
      [button]="cardVirtualButton">
    </ng-ui-kit-card>
  </div>
</app-page-wrapper>

<!-- APP MODAL -->
<app-common-modal
  modalId="app-modal"
  [title]="appModalTitle | translate"
  [(visible)]="appModalVisible"
  [config]="{ size: 'lg', hideButtons: true}"
  (onClose)="onToggleAppModal(false)">
  <div *ngIf="!showRevoke">
    <!-- DOWNLOAD APP SECTION -->
    <div *ngIf="!hasApp">
      <div
        class="ic1-col-12 desc ic1-mt-4 ic1-mb-24"
        [innerHTML]="appModalDesc | translate"></div>

      <div class="line">
        <div class="step-number">1</div>
        <div class="step-text" [innerHTML]="appStepOne | translate"></div>
      </div>

      <div class="image-container">
        <a
          [href]="googlePlayUrl"
          target="_blank"
          [attr.title]="'COMMON.OPENS_NEW_WINDOW' | translate">
          <img
            class="app-image"
            src="assets/images/google-play.png"
            alt="Google Play Store" />
        </a>
        <a
          [href]="appStoreUrl"
          target="_blank"
          [attr.title]="'COMMON.OPENS_NEW_WINDOW' | translate">
          <img
            class="app-image"
            src="assets/images/app-store.png"
            alt="App Store" />
        </a>
      </div>

      <div class="line">
        <div class="step-number">2</div>
        <div class="step-text" translate>{{ appStepTwo }}</div>
      </div>

      <div class="line">
        <div class="step-number">3</div>
        <div class="step-text" translate>{{ appStepThree }}</div>
      </div>

      <div class="buttons-container">
        <ng-ui-kit-button
          color="secondary"
          [label]="'COMMON.BUTTON.CLOSE' | translate"
          type="button"
          size="sm"
          (click)="closeModal()">
        </ng-ui-kit-button>
      </div>
    </div>

    <!-- MANAGE DEVICES SECTION -->
    <div *ngIf="hasApp">
      <div class="desc ic1-mb-20" translate>{{ deviceModalDesc }}</div>

      <div class="cards" *ngFor="let device of filteredDevices">
        <div class="card with-border">
          <div class="card-row">
            <div class="left">
              <img [src]="getDeviceIcon(device.subAuth)" />
              <div class="title ic1-ml-4" translate>
                {{ getDeviceTitle(device.subAuth) }}
              </div>
            </div>
            <a class="action pc" (click)="showRevokeDialog(device)" translate
              >CERT_PAGE.REVOKE</a
            >
          </div>
          <div class="mobile-modal-desc">
            <div
              class="desc"
              [innerHTML]="
                getDeviceDesc()
                  | translate
                    : { device: device.deviceType, user: device.deviceName }
              "></div>
            <a
              class="action mobile"
              (click)="showRevokeDialog(device)"
              translate
              >CERT_PAGE.REVOKE</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- REVOKE CONFIRMATION -->
  <div *ngIf="showRevoke">
    <div class="desc ic1-mb-20" [innerHTML]="revokeConfirmText"></div>
    <div class="buttons-container">
      <ng-ui-kit-button
        color="secondary"
        [label]="'COMMON.BUTTON.CANCEL' | translate"
        type="button"
        size="sm"
        (click)="showRevoke = false">
      </ng-ui-kit-button>
      <app-submit-button
        type="submit"
        [label]="'COMMON.BUTTON.CONFIRM' | translate"
        [disabled]="loading"
        (onClick)="revokeDevice()">
      </app-submit-button>
    </div>
  </div>
</app-common-modal>

<!-- SMS MODAL -->
<app-common-modal
  modalId="sms-modal"
  [title]="'OTP_PAGE.SMS.CHANGE_NUMBER' | translate"
  [(visible)]="smsModalVisible"
  [config]="{ size: 'lg', hideButtons: true }"
  (onClose)="onToggleSmsModal(false)">
  <div *ngIf="!showSuccess">
    <div class="ic1-my-8">
      <div class="desc" translate>OTP_PAGE.SMS.MODAL.DESC</div>
      <div class="under-desc">
        •<span translate>OTP_PAGE.SMS.MODAL.UNDER_DESC_1</span>
      </div>
      <div class="under-desc">
        •<span translate>OTP_PAGE.SMS.MODAL.UNDER_DESC_2</span>
      </div>
    </div>

    <div class="ic1-my-12">
      <ng-ui-kit-toast
        *ngIf="showWarning"
        status="warning"
        [text]="
          'OTP_PAGE.SMS.MODAL.WARNING'
            | translate: { number: telephone || 'N/A' }
        ">
      </ng-ui-kit-toast>
    </div>

    <!-- NON-TRISS USER FORM -->
    <form *ngIf="!isTrissUser" [formGroup]="notTrissOtpForm" class="otpForm">
      <div class="ic1-row">
        <div class="ic1-col-12 ic1-col-lg-6">
          <div class="ic1-form-group">
            <ng-ui-kit-prefix-number-input
              icIdInput="triss-prefix-input-id"
              icIdSelect="triss-prefix-select-id"
              [label]="'OTP_PAGE.SMS.MODAL.PHONE_LABEL' | translate"
              [placeholder]="'OTP_PAGE.SMS.MODAL.PHONE_PLACEHOLDER' | translate"
              formControlName="notTrissTelephoneInput"
              (onChangeSlct)="onSelectChange($event)"
              (onChangeInpt)="onInputChange($event)">
            </ng-ui-kit-prefix-number-input>
          </div>
          <app-field-validator
            *ngIf="notTrissAttempted"
            [field]="notTrissTelephoneInput"
            [formErrors]="notTrissotpFormErrors"></app-field-validator>
        </div>

        <div class="ic1-col-12 ic1-col-lg-6">
          <div class="ic1-form-group">
            <app-otp-input
              resetGroup="sms"
              [label]="'OTP_PAGE.SMS.MODAL.OTP_LABEL' | translate"
              [startTimer]="smsModalVisible"
              [error]="
                notTrissAttempted && notTrissOtp.invalid
              "
              formControlName="notTrissOtp"></app-otp-input>
          </div>
          <app-field-validator
            *ngIf="notTrissAttempted"
            [field]="notTrissOtp"
            [formErrors]="notTrissotpFormErrors"></app-field-validator>
        </div>
      </div>

      <div class="buttons-container">
        <ng-ui-kit-button
          color="secondary"
          [label]="'COMMON.BUTTON.CANCEL' | translate"
          type="button"
          size="sm"
          (click)="closeModal()">
        </ng-ui-kit-button>
        <app-submit-button
          type="submit"
          [label]="'COMMON.BUTTON.SAVE' | translate"
          [loading]="loading"
          [disabled]="loading"
          (onClick)="onOtpSubmit()">
        </app-submit-button>
      </div>
    </form>

    <form *ngIf="isTrissUser" [formGroup]="telephoneForm">
      <div class="ic1-my-16" [ngClass]="{ stepComplete: isStepComplete(0) }">
        <ng-ui-kit-accordion
          [title]="MigrationSteps[0].title | translate"
          [open]="MigrationSteps[0].open"
          [icon]="isStepComplete(0) ? 'check' : ''"
          [step]="isStepComplete(0) ? 0 : MigrationSteps[0].step"
          [disabled]="MigrationSteps[0].disabled">
          <ng-container content>
            <div class="ic1-row">
              <div class="ic1-col-12">
                <div class="ic1-form-group">
                  <div class="ic1-mb-16" translate>
                    OTP_PAGE.SMS.MODAL.PHONE_ACCORDION_DESC
                  </div>

                  <ng-ui-kit-prefix-number-input
                    icIdInput="triss-prefix-input-id"
                    icIdSelect="triss-prefix-select-id"
                    [label]="'OTP_PAGE.SMS.MODAL.PHONE_LABEL' | translate"
                    [placeholder]="
                      'OTP_PAGE.SMS.MODAL.PHONE_PLACEHOLDER' | translate
                    "
                    [selectValue]="defaultCountry"
                    formControlName="telephoneInput"
                    (onChangeSlct)="onSelectChange($event)"
                    (onChangeInpt)="onInputChange($event)">
                  </ng-ui-kit-prefix-number-input>
                </div>
                <app-field-validator
                  *ngIf="trissPhoneAttempted"
                  [field]="telephoneInput"
                  [formErrors]="telephoneFormErrors"></app-field-validator>
              </div>
            </div>

            <div class="buttons-container ic1-mt-16">
              <ng-ui-kit-button
                color="secondary"
                [label]="'COMMON.BUTTON.CANCEL' | translate"
                type="button"
                size="sm"
                (click)="closeModal()">
              </ng-ui-kit-button>
              <app-submit-button
                type="submit"
                [label]="'COMMON.BUTTON.SAVE' | translate"
                [loading]="loading"
                [disabled]="loading"
                (onClick)="openStep(1)">
              </app-submit-button>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>

    <!-- OTP STEP -->
    <form *ngIf="isTrissUser" [formGroup]="otpForm">
      <div class="ic1-my-16" [ngClass]="{ stepComplete: isStepComplete(1) }">
        <ng-ui-kit-accordion
          [title]="MigrationSteps[1].title | translate"
          [open]="MigrationSteps[1].open"
          [icon]="isStepComplete(1) ? 'check' : ''"
          [step]="isStepComplete(1) ? 0 : MigrationSteps[1].step"
          [disabled]="MigrationSteps[1].disabled">
          <ng-container content>
            <div class="ic1-row">
              <div class="ic1-col-12">
                <div translate>OTP_PAGE.SMS.MODAL.OTP_ACCORDION_DESC</div>
              </div>
              <div class="ic1-col-12 ic1-col-lg-6">
                <div class="ic1-form-group">
                  <app-otp-input
                    resetGroup="triss"
                    [startTimer]="MigrationSteps[1].open"
                    [error]="trissOtpAttempted && otp.invalid"
                    formControlName="otp"></app-otp-input>
                </div>
                <app-field-validator
                  *ngIf="trissOtpAttempted"
                  [field]="otp"
                  [formErrors]="otpFormErrors"></app-field-validator>
              </div>
              <div class="ic1-col-12 ic1-col-lg-6">
                <div class="ic1-form-group">
                  <app-confirmation-code
                    resetGroup="triss"
                    formControlName="confirmation_code"
                    [error]="
                      trissOtpAttempted && confirmation_code.invalid
                    "
                    [telephone]="newTelephoneForConfirmation"
                    [hardware]="false"
                    [startTimer]="MigrationSteps[1].open"></app-confirmation-code>
                </div>
                <app-field-validator
                  *ngIf="trissOtpAttempted"
                  [field]="confirmation_code"
                  [formErrors]="otpFormErrors"></app-field-validator>
              </div>
            </div>

            <div class="buttons-container">
              <ng-ui-kit-button
                color="secondary"
                [label]="'COMMON.BUTTON.CANCEL' | translate"
                type="button"
                size="sm"
                (click)="closeModal()">
              </ng-ui-kit-button>
              <app-submit-button
                type="submit"
                [label]="'COMMON.BUTTON.SAVE' | translate"
                [loading]="loading"
                [disabled]="loading"
                (onClick)="onOtpSubmit()">
              </app-submit-button>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>
  </div>

  <!-- SUCCESS STATE -->
  <div *ngIf="showSuccess">
    <div class="success-container">
      <img src="assets/images/modal-success-icon.svg" />
      <div class="success-title" translate>
        OTP_PAGE.SMS.MODAL.SUCCESS_TITLE
      </div>
      <div class="success-desc" translate>OTP_PAGE.SMS.MODAL.SUCCESS_DESC</div>
    </div>
  </div>
</app-common-modal>

<!-- HARDWARE MODAL -->
<app-common-modal
  modalId="hardware-modal"
  [title]="'OTP_PAGE.HARDWARE.TITLE' | translate"
  [(visible)]="hardwareModalVisible"
  [config]="{ size: 'md', hideButtons: true}"
  (onClose)="onToggleHardwareModal(false)">
  <div class="desc ic1-my-16" translate>OTP_PAGE.HARDWARE.MODAL_DESC</div>

  <form [formGroup]="hwForm" class="hwForm">
    <div class="ic1-row ic1-my-16">
      <div class="ic1-col-12 ic1-col-lg-6">
        <app-otp-input
          resetGroup="hardware"
          [hardware]="true"
          [startTimer]="hardwareModalVisible"
          formControlName="hwOtp1"></app-otp-input>
      </div>
      <div class="ic1-col-12 ic1-col-lg-6">
        <app-otp-input
          resetGroup="hardware"
          [hardware]="true"
          [startTimer]="hardwareModalVisible"
          formControlName="hwOtp2"></app-otp-input>
      </div>
    </div>

    <div class="buttons-container">
      <ng-ui-kit-button
        color="secondary"
        [label]="'COMMON.BUTTON.CANCEL' | translate"
        type="button"
        size="sm"
        (click)="closeModal()">
      </ng-ui-kit-button>
      <ng-ui-kit-button
        color="primary"
        [label]="'COMMON.BUTTON.CONFIRM' | translate"
        [disabled]="loading"
        type="submit"
        size="sm"
        (click)="onHWSubmit()">
      </ng-ui-kit-button>
    </div>
  </form>
</app-common-modal>

<!-- VIRTUAL MODAL -->
<app-common-modal
  modalId="virtual-modal"
  [title]="'OTP_PAGE.VIRTUAL.TITLE' | translate"
  [(visible)]="virtualModalVisible"
  [config]="{ size: 'lg', hideButtons: true }"
  (onClose)="onToggleVirtualModal(false)">
  <app-virtual-token-form
    (closeModalEvent)="onToggleVirtualModal(false)"></app-virtual-token-form>
</app-common-modal>
